module.exports = __webpack_public_path__ + "img/brightdualscreen_1000.6a5db373.png";